module.exports = __webpack_public_path__ + "static/media/s1.3dc10d2e.ogg";